// src/components/admin/forms/UserForm.js
import React, { useState, useContext, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
// Import DashboardContext
import { DashboardContext } from "../../../contexts/AdminContext";
import api from "../../../axiosConfig";
import FormNotification, {
  useFormNotification,
} from "../../common/FormNotification";

const UserForm = ({ show, handleClose, initialData = null }) => {
  const { addUser, updateUser } = useContext(DashboardContext);
  const [sectors, setSectors] = useState([]);
  const [loading, setLoading] = useState(false);
  const { notif, notifySuccess, notifyError, clearNotif } =
    useFormNotification();
  const [formData, setFormData] = useState(
    initialData
      ? {
          username: initialData.username,
          role: initialData.role,
          password: "",
          sector_id: initialData.sector_id || "",
        }
      : { username: "", password: "", role: "user", sector_id: "" },
  );

  // Ambil daftar sektor/line untuk dropdown
  useEffect(() => {
    api
      .get("/sectors")
      .then((res) => setSectors(res.data || []))
      .catch((err) => console.error("Gagal ambil sektor:", err));
  }, []);

  // Update formData ketika initialData berubah (misalnya ketika mengedit pengguna yang berbeda)
  useEffect(() => {
    clearNotif();
    setLoading(false);
    if (initialData) {
      setFormData({
        username: initialData.username,
        role: initialData.role,
        password: "",
        sector_id: initialData.sector_id || "",
      });
    } else {
      setFormData({ username: "", password: "", role: "user", sector_id: "" });
    }
  }, [initialData]);

  // Handle perubahan input form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    clearNotif();
    setLoading(true);

    try {
      let result;

      if (initialData) {
        // Update pengguna yang ada
        result = await updateUser(initialData.id, formData);
      } else {
        // Tambah pengguna baru
        result = await addUser(formData);
      }

      if (result && result.success) {
        notifySuccess(
          initialData
            ? "Data pengguna berhasil diperbarui."
            : "Pengguna baru berhasil ditambahkan."
        );
        // Banner sukses tampil sebentar sebelum modal ditutup.
        setTimeout(() => {
          setFormData({
            username: "",
            password: "",
            role: "user",
            sector_id: "",
          });
          handleClose();
        }, 1300);
      } else {
        notifyError(result?.error || "Gagal menyimpan pengguna");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error saat menyimpan pengguna:", error);
      notifyError(error.message || "Terjadi kesalahan saat menyimpan pengguna");
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {initialData ? "Edit Pengguna" : "Tambah Pengguna Baru"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormNotification notif={notif} onClose={clearNotif} />
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              name="username"
              placeholder="Masukkan username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Kata Sandi</Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder="Masukkan kata sandi"
              value={formData.password}
              onChange={handleChange}
              required={!initialData}
            />
            {initialData && (
              <Form.Text className="text-muted">
                Biarkan kosong jika tidak ingin mengubah kata sandi.
              </Form.Text>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Peran</Form.Label>
            <Form.Select
              name="role"
              value={formData.role}
              onChange={handleChange}
            >
              <option value="user">User</option>
              <option value="maintenance">Pemeliharaan</option>
              <option value="teknisi">Teknisi</option>
              <option value="admin">Admin</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Line / Sektor</Form.Label>
            <Form.Select
              name="sector_id"
              value={formData.sector_id || ""}
              onChange={handleChange}
            >
              <option value="">Semua sektor (tidak dikunci)</option>
              {sectors.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </Form.Select>
            <Form.Text className="text-muted">
              Bila dipilih, akun user hanya melihat mesin di line/sektor ini.
            </Form.Text>
          </Form.Group>

          <div className="text-end">
            <Button
              variant="secondary"
              className="me-2"
              onClick={handleClose}
              disabled={loading}
            >
              Batal
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "Menyimpan..." : "Simpan"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default UserForm;
